module.exports = __webpack_public_path__ + "img/ico_caution.0aca29bd.svg";